import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Box, InputLabel, TextField } from '@material-ui/core';

const useStyles = makeStyles({
    inputLabel: {
        color: '#08090a',
        fontSize: '0.875rem',
        fontWeight: '400',
        paddingBottom: '0.625rem',
        display: 'inline-flex !important',
    },
    inputText: {
        color: '#08090a',
        fontSize: '0.875rem',
        width: '100%',
    },
});

export default function FormInput({ inputProps, InputComponentProps, isNoPadding = false, name, id, label, type = 'text', helperText,required = true, value, onKeyDown,onKeyUp, onChange, multiline = false, rows = 5, inputLabelProps = {}, textFieldProps = {}, disabled = false, onPaste }) {
    const classes = useStyles();
    return (
        <Box padding={isNoPadding ? 0 : '0 20px 20px 10px'}>
            <InputLabel className={classes.inputLabel} {...inputLabelProps}>{label}</InputLabel>
            <TextField
                className={classes.inputText}
                required={required}
                id={id}
                variant="outlined"
                disabled={disabled}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                autoComplete='none'
                name={name}
                type={type}
                multiline={multiline}
                InputProps={InputComponentProps}
                inputProps={{ ...inputProps, style: { padding: '0.5rem 1rem', width: '100%' } }}
                helperText={helperText}
                rows={rows}
                onKeyUp={onKeyUp}
                onPaste={onPaste}
                {...textFieldProps} />
        </Box>
    )
}
